import { useCallback, useState } from "react";

import { useTranslation } from "next-i18next";

import Icon from "@components/Icon";
import { useMessage } from "@components/Message";

import { ORDER_MESSAGE_ZONE } from "../../constants";
import type { TOrderFormData } from "../../models/orderForm";
import { loadShipment } from "../../services/loadShipment";
import mapShipmentToOrder from "../../utils/mapShipmentToOrder";

type TLoadShipmentReturn = {
  isLoading: boolean;
  getShipmentEditInfo: (shipmentId?: string) => Promise<TOrderFormData | undefined>;
};

const useEditShipment = (): TLoadShipmentReturn => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const setMessage = useMessage();

  const getShipmentEditInfo = useCallback(
    async (shipmentId?: string) => {
      if (!shipmentId) {
        return undefined;
      }

      setIsLoading(true);

      const result = await loadShipment(shipmentId);

      setIsLoading(false);

      if (!result.isSuccess || !result.data) {
        setMessage({
          message: t("order-message-failed_to_load_shipment"),
          props: {
            variant: "error",
            icon: <Icon icon="warning" size="1.45rem" />,
            canClose: true,
            padding: "0.45rem 0.75rem",
          },
          zone: ORDER_MESSAGE_ZONE,
        });
        return undefined;
      }

      const orderData = mapShipmentToOrder(result.data);

      return orderData;
    },
    [setMessage, t]
  );

  return { isLoading, getShipmentEditInfo };
};
export default useEditShipment;
